import { Notification, NotificationStatus } from '@cp-shared-10/frontend-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditStatus } from '../../utils';

type PaymentDayChangeNotificationProps = {
    editStatus: EditStatus;
};

type NotificationProps = {
    testId: string;
    status: NotificationStatus;
    headline?: string;
    text: string;
};

export const PaymentDayNotification: React.FC<PaymentDayChangeNotificationProps> = ({ editStatus }) => {
    const { t } = useTranslation('financial-details');
    const prefix = 'financing-section.monthly-due-day.edit.notification';

    if (editStatus === EditStatus.NOT_PERFORMED) {
        return null;
    }

    const getNotificationProps = (): NotificationProps | void => {
        switch (editStatus) {
            case EditStatus.SUCCESS:
                return {
                    testId: 'change-success',
                    status: NotificationStatus.warning,
                    headline: t(`${prefix}.success.title`),
                    text: t(`${prefix}.success.text`),
                };
            case EditStatus.ERROR:
                return {
                    testId: 'api-error',
                    status: NotificationStatus.error,
                    text: t(`${prefix}.error.text`),
                };
            case EditStatus.NO_CHANGE:
                return {
                    testId: 'api-error',
                    status: NotificationStatus.warning,
                    headline: t(`${prefix}.not-performed.title`),
                    text: t(`${prefix}.not-performed.text`),
                };
        }
    };

    return <Notification className={editStatus === EditStatus.NO_CHANGE ? 'u-mb' : ''} {...getNotificationProps()} />;
};
